import React, { FunctionComponent } from 'react';

import MainSectionLayout from '@Components/MainSectionLayout';
import ForwardingNumber from '@Containers/UserCallerIds/ForwardingNumber';
import TelnyxCallerIds from '@Containers/UserCallerIds/TelnyxCallerIds';
import TelnyxRotationNumbersContainer from '@Containers/UserCallerIds/TelnyxRotationCallerIds/TelnyxRotationNumbersMain';
import TwilioCallerIds from '@Containers/UserCallerIds/TwilioCallerIds';
import TwilioRotationNumbersContainer from '@Containers/UserCallerIds/TwilioRotationCallerIds/TwilioRotationNumbersMain/TwilioRotationNumbers.container';
import VonageCallerIds from '@Containers/UserCallerIds/VonageCallerIds';
import VonageRotationCallerIdsContainer from '@Containers/UserCallerIds/VonageRotationCallerIds/VonageRotationCallerIdsContainer';
import { VoiceProvider } from '@Models/callerIds.models';
import {
  useTokenAccIdValueHook,
  useTokenTprValueHook,
} from '@Utils/hooks/useTokenValues.hook';
import useVoiceProvider from '@Utils/hooks/useVoiceProvider.hook';

const UserCallerIds: FunctionComponent = (): JSX.Element => {
  const hasTpr = useTokenTprValueHook();
  const accountId = useTokenAccIdValueHook();

  const { userVoiceProvider, loading } = useVoiceProvider(
    accountId?.toString() || ''
  );

  const getRotationAndForwardingContainer = () => {
    if (hasTpr && userVoiceProvider === VoiceProvider.TWILIO) {
      return <TwilioRotationNumbersContainer />;
    }
    if (hasTpr && userVoiceProvider === VoiceProvider.TELNYX) {
      return <TelnyxRotationNumbersContainer />;
    }
    if (userVoiceProvider === VoiceProvider.VONAGE) {
      return (
        <>
          <MainSectionLayout filters={<ForwardingNumber />} />
          {hasTpr && <VonageRotationCallerIdsContainer />}
        </>
      );
    }
  };

  return (
    <>
      {!loading && userVoiceProvider && (
        <>
          {(() => {
            if (userVoiceProvider === VoiceProvider.TWILIO) {
              return <TwilioCallerIds />;
            }
            if (userVoiceProvider === VoiceProvider.TELNYX) {
              return <TelnyxCallerIds />;
            }
            return <VonageCallerIds />;
          })()}
          {getRotationAndForwardingContainer()}
        </>
      )}
    </>
  );
};

export default UserCallerIds;
